export const CHARACTER_API_URL = 'https://rickandmortyapi.com/api/character';
export const EPISODE_API_URL = 'https://rickandmortyapi.com/api/episode';